import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const SearchBar = ({ variant = "default", initialQuery = "", initialCity = "" }) => {
  const [query, setQuery] = useState(initialQuery);
  const [city, setCity] = useState(initialCity);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (query) params.set("q", query);
    if (city) params.set("city", city);
    navigate(`/recherche?${params.toString()}`);
  };

  const isLarge = variant === "large";

  return (
    <form onSubmit={handleSubmit} className="w-full" data-testid="search-form">
      <div className={`flex flex-col md:flex-row gap-3 ${isLarge ? "md:gap-4" : "md:gap-2"}`}>
        {/* Query Input */}
        <div className="relative flex-1">
          <Search className={`absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 ${isLarge ? "w-5 h-5" : "w-4 h-4"}`} />
          <Input
            type="text"
            placeholder="Nom, activité, mot-clé..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className={`pl-12 ${isLarge ? "h-14 text-lg" : "h-12"} bg-white border-slate-300 focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20`}
            data-testid="search-query-input"
          />
        </div>

        {/* City Input */}
        <div className="relative flex-1 md:max-w-xs">
          <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 ${isLarge ? "w-5 h-5" : "w-4 h-4"}`} />
          <Input
            type="text"
            placeholder="Ville ou département"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className={`pl-12 ${isLarge ? "h-14 text-lg" : "h-12"} bg-white border-slate-300 focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20`}
            data-testid="search-city-input"
          />
        </div>

        {/* Submit Button */}
        <Button
          type="submit"
          className={`${isLarge ? "h-14 px-8 text-lg" : "h-12 px-6"} bg-[#FFD700] text-slate-900 font-bold hover:bg-[#E6C200] active:scale-95`}
          data-testid="search-submit-btn"
        >
          <Search className={`${isLarge ? "w-5 h-5" : "w-4 h-4"} mr-2`} />
          Rechercher
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;
